module.exports = __webpack_public_path__ + "img/maintenance3.8832c38c.png";